export default "__VITE_ASSET__eYN2dAbJ__"